"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var page_header_footer_options_html_1 = __importDefault(require("./page-header-footer-options.html"));
(function (module) {
    module.component('prPageHeaderFooterOptions', {
        templateUrl: page_header_footer_options_html_1.default,
        controller: 'prHeaderFooterOptionsController as $ctrl',
        replace: true,
        bindings: {
            type: '=',
            typeModel: '='
        }
    });
})(angular.module('qualtrics.pr'));
